import { matchesDateFilter } from './formats';
import { ColumnDef, ColumnId, DateFilterState, FilterState, SortState } from './types';

export function processRows<T>(
  rows: T[],
  columns: ColumnDef<T>[],
  filters: FilterState,
  sort: SortState,
  dateFilters: DateFilterState = {}
): T[] {
  const byId = new Map<string, ColumnDef<T>>();
  for (const c of columns) byId.set(c.id, c);

  let out: T[] = rows;

  for (const [columnId, values] of Object.entries(filters) as [ColumnId, Set<string> | undefined][]) {
    if (!values || values.size === 0) continue;
    const col = byId.get(columnId);
    if (!col) continue;
    out = out.filter((r) => values.has(col.accessor(r)));
  }

  for (const [columnId, df] of Object.entries(dateFilters)) {
    if (!df) continue;
    const col = byId.get(columnId);
    if (!col) continue;
    out = out.filter((r) => matchesDateFilter(r, col, df));
  }

  if (sort.length > 0) {
    out = [...out].sort((a, b) => {
      for (const crit of sort) {
        const col = byId.get(crit.columnId);
        if (!col) continue;
        const av = col.sortValue(a);
        const bv = col.sortValue(b);
        if (av < bv) return crit.direction === 'asc' ? -1 : 1;
        if (av > bv) return crit.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  return out;
}
